import { RefBase } from "@tblabs/truffle";


export class RefWatcher
{
    public static Watch(refs: RefBase[], doWhenAnyRefChange: () => void)
    {
        refs.forEach(ref =>
        {
            ref.OnChange(v => {
                doWhenAnyRefChange();
            });
        });

        doWhenAnyRefChange();
    }
}
